// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".squad:not(.squad_empty) {\n  padding-top: 1rem;\n}\n\n@media (min-width: 990px) {\n}\n", "",{"version":3,"sources":["webpack://./src/pages/Squad/containers/index.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;AACA","sourcesContent":[".squad:not(.squad_empty) {\n  padding-top: 1rem;\n}\n\n@media (min-width: 990px) {\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
